// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__1pVVM","info_container":"About_info_container__oOdn6","pic_container":"About_pic_container__166Zd"};